var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex justify-between"},[(_vm.label)?_c('div',{staticClass:"ds-text-base font-bold text-gray-800 uppercase mb-3"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()]),(_vm.isList)?_c('VideoListView',{attrs:{"videos":_vm.videos}}):_vm._e(),(_vm.isGrid)?_c('VideoGridView',{attrs:{"videos":_vm.videos}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }